<template>
  <b-container fluid>
    <b-spinner v-if="!loaded && loading" big label="Loading..."></b-spinner>
    <div v-else-if="loaded">
      <b-row no-gutters>
        <b-col cols="12" class="mb-3">
          <settings :id="id" />
        </b-col>

        <b-col cols="12" class="mb-3">
          <freeDays :id="id" @changed="getData" />
        </b-col>
      </b-row>

      <b-row no-gutters class="formContainer">
        <b-col md="6">
          <h3>Kursant zrealizował łącznie {{cyclesCount}}</h3>
        </b-col>
        <b-col md="6" class="text-right">
        
          <b-button
            type="submit"
            variant="primary"
            :disabled="generatingNewCycle"
            @click="generateNewCycle"
          >
            <span v-show="!generatingNewCycle">Generuj kolejny makrocykl</span>
            <span v-show="generatingNewCycle">
              <b-spinner small label="Proszę czekać..."></b-spinner>
            </span>
          </b-button>

            <b-button
            type="submit"
            variant="info"
            :disabled="generatingNewTalksOnlyCycle"
            @click="generateNewTalksOnlyCycle"
          >
            <span v-show="!generatingNewTalksOnlyCycle">Generuj kolejny makrocykl z samymi rozmowami</span>
            <span v-show="generatingNewTalksOnlyCycle">
              <b-spinner small label="Proszę czekać..."></b-spinner>
            </span>
          </b-button>

        </b-col>
        <b-col cols="12">
          <hr />
        </b-col>
        <b-col
          cols="12"
          v-for="cycle in cycles"
          :key="cycle.id"
          @click.prevent="selectedCycleId = cycle.id"
        >
          <item
            :key="cycle.id"
            class="item"
            :class="{'selected-item': selectedCycleId == cycle.id}"
            :cycle="cycle"
            @edit="showEditCycleModal(cycle)"
          />
        </b-col>
      </b-row>
      <b-row no-gutters v-if="selectedCycleId">
        <b-col cols="12">
          <cycleDetails :key="selectedCycleId" :id="selectedCycleId" />
        </b-col>
      </b-row>
    </div>
    <editCycleModal ref="editCycleModal" @save="onEditCycle" />
  </b-container>
</template>

<script>
import { axios, eventBus } from "@/_infrastructure";
import item from "./DetailsCycleItem";
import editCycleModal from "./DetailsCycleEditModal";
import cycleDetails from "./DetailsCycleDetails";
import settings from "./LearningCycleSettings";

import freeDays from "./DetailsFreeDays";

export default {
  components: { item, settings, editCycleModal, cycleDetails, freeDays },
  data() {
    return {
      cycles: [],
      selectedCycleId: null,
      settings: null,
      loading: false,
      generatingNewCycle: false,
      generatingNewTalksOnlyCycle: false,
      loaded: false
    };
  },
  mounted() {
    this.loading = true;
    this.getData();
  },
  computed: {
    cyclesCount: function() {
      var quantity = this.cycles.length;
      if (quantity % 10 === 1) return `${quantity} makrocykl`;
      if (quantity % 10 > 1 && quantity % 10 < 5)
        return `${quantity} makrocykle`;
      return `${quantity} makrocykli`;
    }
  },
  props: ["id"],
  methods: {
    generateNewCycle() {
      this.generatingNewCycle = true;
      axios
        .post("/students/cycles/generateNew/regular", {
          userId: this.id
        })
        .then(() => {
          this.getData();
        })
        .catch(err => {
          eventBus.$emit("unhandled-error", err);
        })
        .then(() => {
          this.generatingNewCycle = false;
        });
    },
    generateNewTalksOnlyCycle() {
      this.generatingNewTalksOnlyCycle = true;

      axios
        .post("/students/cycles/generateNew/talksOnly", {
          userId: this.id
        })
        .then(() => {
          this.getData();
        })
        .catch(err => {
          eventBus.$emit("unhandled-error", err);
        })
        .then(() => {
          this.generatingNewTalksOnlyCycle = false;
        });
    },
    showEditCycleModal(cycle) {
      this.$refs.editCycleModal.show(cycle);
    },
    onEditCycle(r) {
      window.console.log(r);
      axios
        .put("/students/cycles/details", r)
        .then(() => {
          this.getData();
          eventBus.$emit("success", "Zapisano poprawnie");
        })
        .catch(err => {
          eventBus.$emit("unhandled-error", err);
        })
        .then(() => {});

      window.console.log(r);
    },
    getData() {
      this.loading = true;
      return axios
        .get("/students/cycles", {
          params: {
            id: this.id
          }
        })
        .then(response => {
          var result = response.data;
          this.cycles = result.cycles;
          this.settings = result.settings;
          this.loaded = true;
        })
        .catch(err => {
          eventBus.$emit("unhandled-error", err);
        })
        .then(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
button {
  margin-right: 3px;
  margin-bottom: 10px;
}
.item {
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 5px;
  padding: 7px;
  margin: 3px;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.03);
}
.selected-item {
  background: rgba(0, 255, 0, 0.125);

  &:hover {
    background: rgba(0, 255, 0, 0.25);
  }
}
</style>

